import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MatListItemLine, MatListItemTitle, MatListOption, MatSelectionList} from "@angular/material/list";
import {MatButton} from "@angular/material/button";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {NotificationPreferencesBase} from "./notificaton-preferences-base.component";
import {GameService} from "../../services/game.service";
import {ContainerComponent} from "@coreui/angular";

/**
 * Single scope-aware notification-preferences page, replacing the former
 * cross-game / game-admin pair. Scope comes from route data (`isCrossGame`):
 *   - global route  -> data: { isCrossGame: true }  — show the game picker, load on choose
 *   - game route     -> data: { isCrossGame: false } — load the active game's prefs immediately
 */
@Component({
  selector: 'app-notification-preferences',
  standalone: true,
  imports: [
    MatButton,
    MatListOption,
    MatListItemTitle,
    MatListItemLine,
    MatProgressSpinner,
    MatSelectionList,
    ChooseYourGameComponent,
    ContainerComponent
  ],
  templateUrl: './notification-preferences.html',
})
export class NotificationPreferencesComponent extends NotificationPreferencesBase {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);

  constructor() {
    super();
    this.isCrossGame = this.route.snapshot.data['isCrossGame'] === true;

    if (!this.isCrossGame) {
      this.game = this.gameService.activeGame();
      this.fetchNotificationPreferenceData();
    }
  }
}
